export default __webpack_public_path__ + "static/media/avatar.58c525d1.webp";